import { Form } from '../core'

$.fn.NewsletterForm = function() {
  let self = this
  self.section = self.closest('.newsletter')

  self.initialize_form = function() {
    new Form(self.get(0), {
      ajax_redirect: false,
      auto_scroll: false,
      floating_labels: true,
      onSubmit: function() {
        self.addClass('newsletter-form--blocked')
      },
      onSuccess: function() {
        self.fadeOut(250, function() {
          let $success = $('<p class="form-success form-success--newsletter">')
          $success.text(theatredesjardins_l10n.NEWSLETTER_SENT).hide()
          self.section.css('height', self.section.outerHeight(false) + 'px')
          self.after($success.fadeIn(250))
          self.remove()
          requestAnimationFrame(function() {
            self.section.css('height', '')
          })
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('newsletter-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.SchoolForm = function() {
  let self = this
  self.section = self.closest('.school')

  self.initialize_form = function() {
    new Form(self.get(0), {
      ajax_redirect: false,
      auto_scroll: false,
      floating_labels: true,
      onSubmit: function() {
        self.addClass('school-form--blocked')
      },
      onSuccess: function() {
        self.find('.form-border').css('height', (self.find('.form-border > div').outerHeight(false) + 14) + 'px')
        self.find('.submit-container').fadeOut(250)
        self.find('.fields-wrapper').fadeOut(250, function() {
          let $success = $('<p class="form-success form-success--school">')
          $success.text(theatredesjardins_l10n.SCHOOL_SENT).hide()
          self.find('.form-border h2').after($success.fadeIn(250))
          self.find('.submit-container, .fields-wrapper').remove()
          self.find('.form-border').css('height', self.find('.form-border > div').outerHeight(false) + 'px')
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('school-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.VenueForm = function() {
  let self = this
  self.section = self.closest('.venue')

  self.initialize_form = function() {
    new Form(self.get(0), {
      ajax_redirect: false,
      auto_scroll: false,
      floating_labels: true,
      onSubmit: function() {
        self.addClass('venue-form--blocked')
      },
      onSuccess: function() {
        self.find('.form-border').css('height', (self.find('.form-border > div').outerHeight(false) + 14) + 'px')
        self.find('.submit-container').fadeOut(250)
        self.find('.fields-wrapper').fadeOut(250, function() {
          let $success = $('<p class="form-success form-success--venue">')
          $success.text(theatredesjardins_l10n.VENUE_SENT).hide()
          self.find('.form-border h2').after($success.fadeIn(250))
          self.find('.submit-container, .fields-wrapper').remove()
          self.find('.form-border').css('height', self.find('.form-border > div').outerHeight(false) + 'px')
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('venue-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}
